export default __webpack_public_path__ + "static/media/bus.4587ab07.svg";